import { useTranslation } from "react-i18next";
import { useGetGlobalParameters } from "@/api/globalParameters.api";
import StyledSpinner from "@/components/styled/StyledSpinner";
import { ParameterInsurance } from "@/components/backOffice/parameters/options/insurance/optionsInsurance";
import { ParameterWoodBox } from "@/components/backOffice/parameters/options/woodbox/optionsWoobox";
import { OptionsMembrane } from "@/components/backOffice/parameters/options/membrane/optionsMembrane";
import { OptionsPaymentTerm } from "@/components/backOffice/parameters/options/paymentTerm/optionsPaymentTerm";
import { OptionsRib } from "@/components/backOffice/parameters/options/rib/optionsRib";
import { ParametersHeader } from "@/components/shared/parametersHeader";

export const OptionsParameterPage = () => {
  const { t } = useTranslation("boParameters");
  const { data: globalParameters } = useGetGlobalParameters();

  if (!globalParameters) return <StyledSpinner />;

  return (
    <ParametersHeader>
      <div className="flex w-full flex-1 flex-col items-center gap-6 lg:px-8">
        <div className="flex w-full flex-col gap-2">
          <h2 className="text-lg font-semibold">{t("optionsPage.title")}</h2>
          <p className="text-sm text-gray-600">{t("optionsPage.description")}</p>
        </div>
        <ParameterInsurance insurance={globalParameters.insurancePercentage || 0} />
        <OptionsMembrane woodBoxMembranesPriceHT={globalParameters.woodBoxMembranesPriceHT} />
        <OptionsPaymentTerm defaultPaymentTerm={globalParameters.defaultPaymentTerm} />
        <OptionsRib />
        <ParameterWoodBox woodBoxesPrice={globalParameters.woodBoxesPrice} />
      </div>
    </ParametersHeader>
  );
};
